import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as conversations from '../../conversations'

export const RESOURCE = {
  payload: {
    description:
      'A threaded exchange between users and agents, consisting of multiple messages over time.',
    dimension: conversations.RESOURCE.payload,
    level: 0,
    name: 'Conversation',
    partialId: PartialId.Standard.create('conversation'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
